import request from './request'

// 超话
export async function hyperChat(data) {
    return request({
        url: 'api/hyperChat',
        method: 'post',
        data
    })
}
// 获取所有语境
export async function getAllContextMeta(data) {
    return request({
        url: 'api/all_context_meta',
        method: 'get',
        data
    })
}
// 获取历史记录
export async function getHistoryMessages(data) {
    return request({
        url: `api/history_messages/${data['context_id']}`,
        method: 'get'
    })
}
// 清除历史记录
export async function delHistoryMessages(data) {
    return request({
        url: `api/history_messages/${data['context_id']}`,
        method: 'delete'
    })
}
// 在售产品
export async function getProductsList(data) {
    return request({
        url: `api/products/all`,
        method: 'get'
    })
}
//模型列表
export async function getLlmModelList(data) {
    return request({
        url: `api/llm_prepaid_card/model_list`,
        method: 'get'
    })
}
//常见问题
export async function getCommonQaList(data) {
    return request({
        url: `api/llm_prepaid_card/common_qa`,
        method: 'get'
    })
}

export async function buyllm(data) {
    return request({
        url: `/api/vCNY/prepaid_card/apply/${data['product_id']}`,
        method: 'get'
    })
}
export async function returnllm(data) {
    return request({
        url: `/api/vCNY/prepaid_card/cancel/${data['card_id']}`,
        method: 'get'
    })
}
// 更新语境元信息
export async function setContextMeta(data) {
    return request({
        url: 'api/update_context_meta',
        method: 'put',
        data
    })
}
// 上传图片
export async function hyperChatUploadImage(data) {
    return request({
        url: 'api/hyperChat/upload/image',
        method: 'post',
        data
    })
}
// chat回答者列表
export async function getChatResponderList(data) {
    return request({
        url: 'api/chat_responder_list',
        method: 'get',
        data
    })
}
//新建chat
export async function addNewChat(data) {
    return request({
        url: 'api/new_chat',
        method: 'post',
        data
    })
}
//新建chat
export async function addNewChatBranch(data) {
    return request({
        url: 'api/create_chat_branch',
        method: 'post',
        data
    })
}
//删除chat
export async function delChat(data) {
    return request({
        url: `api/chat_scenario/${data['context_id']}`,
        method: 'delete'
    })
}
